import axios from 'axios'
import { APPKEYs, URLs } from '@/config'

let restAPIKey = APPKEYs.kakaomap

const https = axios.create({
    baseURL: "https://dapi.kakao.com"
});

https.interceptors.request.use(
    config => {
        config['headers'] = {
            Accept: "application/json, text/plain, */*",
            Authorization: `KakaoAK ${restAPIKey}`
        }
        console.log("rest local map:", config);
        return config;
    })

https.interceptors.response.use(
    response => { return response },
    error => {
        console.log(error);
    })

export const mapapi = {
    get: {
        searchRoadName: async (params) => {
            return await https.get(
                `${URLs.kakao}/search/address.json`,
                {
                    params,
                }
            )
        },
    }
}



// WEBPACK FOOTER //
// ./src/api/localMap.js